export default "__VITE_ASSET__b6768dbf__"